// import React, { useState } from "react";
// import { Modal, Button, Form, Spinner } from "react-bootstrap";
// import { FaPlus } from "react-icons/fa";
// import { useMutation, useQueryClient } from "react-query";
// import { useAlerts } from "../../../context/AlertContext";
// import api from "../../../utils/helper";

// const AddLink = ({ show, close, lessonID }) => {

//     const [links, setLinks] = useState([{ link: "", order: 1 }]);
//     const { showSuccess, showError } = useAlerts();
//     const QueryClient = useQueryClient();

//     const handleInputChange = (index, value) => {
//         const newLinks = [...links];
//         newLinks[index].link = value;
//         setLinks(newLinks);
//     };

//     const addNewLink = () => {
//         setLinks([...links, { link: "", order: links.length + 1 }]);
//     };

//     const removeLink = (index) => {
//         const newLinks = links.filter((_, i) => i !== index);
//         // Update order after deletion
//         const updatedLinks = newLinks.map((item, i) => ({ ...item, order: i + 1 }));
//         setLinks(updatedLinks);
//     };

//     const addLinkMutation = useMutation(
//         (lesson) => api.post(`/lessons/${lessonID}/modules`, lesson, "add-lesson"), {
//         onSuccess: (response) => {

//             //   queryClient.invalidateQueries(["lessons", { id: courseId }]);
//             QueryClient.invalidateQueries(["lessons"]);
//             close();
//             setLinks([{ link: "", order: 1 }])
//             showSuccess(response.data?.message || "Links added successfully!");

//         },
//         onError: (error) => {
//             // Handle API errors
//             console.error("Error adding Links:", error);
//             showError(error.response?.data?.message || "Error adding Links. Please try again.");
//         },
//     });

//     const handleLinkSubmit = () => {
//         console.log("Submitted Links:", links.filter(item => item.link.trim() !== ""));
//         addLinkMutation.mutate({ preRecordLinks: links.filter(item => item.link.trim() !== "") })
//     };

//     return (
//         <Modal show={show} onHide={close} centered>
//             <Modal.Header className="d-flex flex-column gap-4">
//                 <div className="youtubeImas">
//                     <img src="images/youtube_1.png" alt="Youtube" />
//                 </div>
//                 <Modal.Title className="externalUrl">Enter YouTube URLs</Modal.Title>
//                 <p className="publishright">
//                     Make sure you have the rights to publish these.
//                 </p>
//             </Modal.Header>
//             <Modal.Body className="urllink">
//                 {links.map((item, index) => (
//                     <div key={index} className="mb-3 d-flex align-items-center">
//                         <Form.Control
//                             type="url"
//                             placeholder="Enter external URL"
//                             value={item.link}
//                             onChange={(e) => handleInputChange(index, e.target.value)}
//                         />
//                         {links.length > 1 && (
//                             <Button variant="danger" className="ms-2" onClick={() => removeLink(index)}>
//                                 ×
//                             </Button>
//                         )}
//                     </div>
//                 ))}
//                 <div className="d-flex justify-content-end">
//                     <div className="plusIcon" onClick={addNewLink} style={{ cursor: "pointer" }}>
//                         <FaPlus size={20} />
//                     </div>
//                 </div>
//             </Modal.Body>
//             <Modal.Footer className="justify-content-between w-auto">
//                 <Button variant="outline-secondary" className="me-2 btnSaves" onClick={close}>
//                     Cancel
//                 </Button>
//                 <Button color="#60B1FF" className="btnSaves" onClick={handleLinkSubmit}>
//                     {addLinkMutation.isLoading && <Spinner size="sm" />}  Save
//                 </Button>
//             </Modal.Footer>
//         </Modal>
//     );
// };

// export default AddLink;

//-----------------------------------------

import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { useMutation, useQueryClient } from "react-query";
import { useAlerts } from "../../../context/AlertContext";
import api from "../../../utils/helper";

const AddLink = ({ show, close, lessonID, existingModule, setLinkCount }) => {
  const [links, setLinks] = useState([{ link: "", order: 1 }]);
  const [lesson, setLesson] = useState([]);
  const { showSuccess, showError } = useAlerts();
  const QueryClient = useQueryClient();

  // Populate existing links when module exists
  useEffect(() => {
    if (existingModule && existingModule.preRecordLinks) {
      setLinks(
        existingModule.preRecordLinks.length > 0
          ? existingModule.preRecordLinks
          : [{ link: "", order: 1 }]
      );
    }
  }, [existingModule, show]);

  // Update link count whenever links change
  useEffect(() => {
    setLinkCount(links.filter((item) => item.link.trim() !== "").length); // count non-empty links
  }, [links, setLinkCount]);

  //   useEffect(() => {
  //     console.log("Updated lesson:", lesson);
  //   }, [lesson]);

  const handleInputChange = (index, value) => {
    setLinks((prevLinks) => {
      const newLinks = [...prevLinks];
      newLinks[index].link = value;
      return newLinks;
    });
    // const newLinks = [...links];
    // newLinks[index].link = value;
    // setLinks(newLinks);
  };

  const addNewLink = () => {
    setLinks([...links, { link: "", order: links.length + 1 }]);
  };

  const removeLink = (index) => {
    const newLinks = links.filter((_, i) => i !== index);
    // Update order after deletion
    const updatedLinks = newLinks.map((item, i) => ({ ...item, order: i + 1 }));
    setLinks(updatedLinks);
  };

  const linkMutation = useMutation(
    (data) =>
      existingModule
        ? api.put(
            `/lessons/${lessonID}/modules/${existingModule._id}`,
            data,
            "update-lesson-module"
          )
        : api.post(`/lessons/${lessonID}/modules`, data, "add-lesson-module"),
    {
      onSuccess: async (response) => {
        await QueryClient.invalidateQueries(["lessons"]); // Ensure lessons refresh

        // Fetch latest lesson data and update state
        const updatedLessonResponse = await api.get(`/lessons/${lessonID}`);
        const updatedLesson = updatedLessonResponse.data;
        setLesson(updatedLesson);
        // Update lesson state to trigger UI re-render
        // setLesson((prevLessons) =>
        //   prevLessons.map((lesson) =>
        //     lesson._id === updatedLesson._id ? updatedLesson : lesson
        //   )
        // );
        //setLesson(updatedLesson.data); // Ensure lesson state updates immediately

        close();
        showSuccess(
          response.data?.message ||
            `${existingModule ? "Updated" : "Added"} links successfully!`
        );
        // QueryClient.invalidateQueries(["lessons"]);
        // setLinks(response.data?.preRecordLinks || [{ link: "", order: 1 }]); // Ensure new links are set

        // Update lesson state (if applicable)
        // setLesson((prevLesson) => ({
        //   ...prevLesson,
        //   modules: prevLesson?.modules?.map((module) =>
        //     module._id === existingModule?._id
        //       ? { ...module, preRecordLinks: response.data?.preRecordLinks }
        //       : module
        //   ),
        // }));
        // close();

        //setLinks([{ link: "", order: 1 }]);
        // showSuccess(
        //   response.data?.message ||
        //     `${existingModule ? "Updated" : "Added"} links successfully!`
        // );
      },
      onError: (error) => {
        console.error("Error managing Links:", error);
        showError(
          error.response?.data?.message ||
            "Error managing Links. Please try again."
        );
      },
    }
  );

  const handleLinkSubmit = () => {
    const filteredLinks = links.filter((item) => item.link.trim() !== "");
    if (filteredLinks.length === 0) {
      showError("Please add at least one link");
      return;
    }

    linkMutation.mutate({ preRecordLinks: filteredLinks });
  };

  return (
    <Modal show={show} onHide={close} centered>
      <Modal.Header className="d-flex flex-column gap-4">
        <div className="youtubeImas">
          <img src="images/youtube_1.png" alt="Youtube" />
        </div>
        <Modal.Title className="externalUrl">
          {existingModule ? "Edit" : "Enter"} YouTube URL
        </Modal.Title>
        <p className="publishright">
          Make sure you have the rights to publish this.
        </p>
      </Modal.Header>
      <Modal.Body className="urllink">
        {links.map((item, index) => (
          <div key={index} className="mb-3 d-flex flex-column">
            <Form.Label>
              Enter URL <span className="text-danger">*</span>
            </Form.Label>
            <div className="d-flex">
              <Form.Control
                type="url"
                placeholder="Enter external URL"
                value={item.link}
                onChange={(e) => handleInputChange(index, e.target.value)}
              />
              {links.length > 1 && (
                <Button
                  variant="danger"
                  className="ms-2"
                  onClick={() => removeLink(index)}
                >
                  ×
                </Button>
              )}
            </div>
          </div>
        ))}

        {/* Display YouTube Links Preview */}
        {/* {links.some((link) => link.link.trim() !== "") && (
          <div className="mt-3">
            <h5>Preview:</h5>
            {links.map((item, index) =>
              item.link ? (
                <div key={index} className="mb-2">
                  <a href={item.link} target="_blank" rel="noopener noreferrer">
                    {item.link}
                  </a>
                </div>
              ) : null
            )}
          </div>
        )} */}

        <div className="d-flex justify-content-end">
          <div
            className="plusIcon"
            onClick={addNewLink}
            style={{ cursor: "pointer" }}
          >
            <FaPlus size={20} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="justify-content-between w-auto flex-nowrap">
        <Button
          variant="outline-secondary"
          className="me-2 btnSaves w-50"
          onClick={close}
        >
          Cancel
        </Button>
        <Button
          color="#60B1FF"
          className="btnSaves w-50"
          onClick={handleLinkSubmit}
          disabled={linkMutation.isLoading}
        >
          {linkMutation.isLoading ? <Spinner size="sm" /> : "Save"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AddLink;
